import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import publicProfileLogo from '../../assets/images/Profile/public_prof_logo.png';
import { GlobalUncContext } from '../../Components/Layout/Layout';
import useClickOutside from '../../Hooks/useClickOutside';
import { allFollowersPeoplesData } from '../../Shared/GlobalDataFactory';

import './PublicProfile.scss';

export interface IPublicProfileProps {
}

export function PublicProfile(props: IPublicProfileProps) {
    const { setRecentActOpen, handleMessageBtnInPubProfile } = React.useContext(GlobalUncContext)

    const [isFollow, setIsFollow] = useState(false);


    const messageBtnOnClick = () => {
        const newMessage = {
            name: 'Kitty world',
            isGroup: false,
            chatProfilePhoto: publicProfileLogo,
            inboxMessages: []
        }
        handleMessageBtnInPubProfile(newMessage)
    }


    // ---------------------Profile Share modal---------------------
    const [shareModalOpen, setShareModalOpen] = useState(false);
    const shareModalRef = useRef(null);
    useClickOutside(shareModalRef, () => setShareModalOpen(false))

    const [modalPeoplesData, setModalPeoplesData] = useState(allFollowersPeoplesData)

    const handleShareModalSearch = (e: any) => {
        const prevModalPeopleData = [...allFollowersPeoplesData]
        const findMatchPeoples = prevModalPeopleData.filter(data => data.name.toLowerCase().includes(e.target.value.toLowerCase()))

        setModalPeoplesData(findMatchPeoples);
    }

    // ------------three dot modal------------
    const [threeDotModalOpen, setThreeDotModalOpen] = useState(false);
    const threeDotModalRef = useRef(null);
    useClickOutside(threeDotModalRef, () => setThreeDotModalOpen(false))





    // -------------------Followers Modal-------------------
    const [showFollowersModal, setShowFollowersModal] = useState(false)
    const followersModalRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(followersModalRef, () => setShowFollowersModal(false))

    // -------------------Followers Modal-------------------
    const [showFollowingModal, setShowFollowingModal] = useState(false)
    const followingModalRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(followingModalRef, () => setShowFollowingModal(false))

    const SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
    const abbreviateNumber = (number: any) => {
        const tier = Math.log10(Math.abs(number)) / 3 | 0;
        if (tier === 0) return number;
        const suffix = SI_SYMBOL[tier];
        const scale = Math.pow(10, tier * 3);
        const scaled = number / scale;
        return scaled.toFixed(1) + suffix;
    }



    // ---------------------Report Modal---------------------
    const [reportModalOpen, setReportModalOpen] = useState(false);
    const reportModalRef = useRef(null);
    useClickOutside(reportModalRef, () => setReportModalOpen(false));

    const [reasonDropOpen, setReportDropOpen] = React.useState(false)
    const [reasonText, setReasonText] = React.useState('Select a reason');
    let reasonDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(reasonDropRef, () => setReportDropOpen(false))




    const smallNavItemStyles = 'text-cusGray xs:text-xs sm:text-base font-bold xs:px-2 sm:px-4 small_nav_item pb-4';
    return (
        <div className="public_profile_min_box
        pt-[64px]
        sm:pt-[80px]">

            <div className="xs:py-9 sm:py-0 h-[218px] sm:h-[248px] md:h-[320px] w-full top_section bg-cover bg-center flex justify-center items-center bg-no-repeat relative">
                <div className="hidden dark:block bg-[#00000090] absolute top-0 left-0 w-full h-full"></div>



                <div className="px-5 xsm:px-8 sm:px-0 sm:max-w-[570px] md:max-w-[660px] lg:max-w-[900px] xl:max-w-[1100px] 2xl:max-w-[1336px] 3xl:max-w-[1436px]
                mx-auto flex lg:flex-row flex-col justify-center lg:justify-between items-start lg:items-center w-full h-fit relative">

                    <div className="flex-1 flex justify-start items-center">
                        <div>
                            <div className="rounded-full profile_logo_bg bg-[#6666c5af]
                        h-[90px] w-[90px]
                        xsm:h-[100px] xsm:w-[100px]
                        sm:h-[110px] sm:w-[110px]
                        md:h-[110px] md:w-[110px]
                        lg:h-[130px] lg:w-[130px]
                        xl:h-[150px] xl:w-[150px]
                        2xl:h-[170px] 2xl:w-[170px]
                        ">
                                <div className="w-full h-full dark:bg-cusBlack rounded-full p-1 sm:p-1.5">
                                    <img src={publicProfileLogo} alt="" className="w-full h-full" />
                                </div>
                            </div>
                        </div>

                        <div className="ml-2 xsm:ml-4 lg:ml-8 text-left xs:mt-2 sm:mt-0">
                            <div className="flex justify-start items-center">
                                <h4 className="inline-block text-sm xsm:text-base lg:text-lg xl:text-xl mr-1 text-white font-bold">Kitty world</h4>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className="w-6 sm:w-9 -mb-1.5" viewBox="0 0 35.74 35.673">
                                    <defs>
                                        <filter id="Path_682" x={0} y={0} width="35.74" height="35.673" filterUnits="userSpaceOnUse">
                                            <feGaussianBlur stdDeviation={3} result="blur" />
                                            <feFlood floodColor="#f08" floodOpacity="0.314" />
                                            <feComposite operator="in" in2="blur" />
                                            <feComposite in="SourceGraphic" />
                                        </filter>
                                    </defs>
                                    <g id="Group_1214" data-name="Group 1214" transform="translate(-546.155 -743.31)">
                                        <g transform="matrix(1, 0, 0, 1, 546.15, 743.31)" filter="url(#Path_682)">
                                            <path id="Path_682-2" data-name="Path 682" d="M631.76,279.583s7.714-1.937,14.928,0a34.6,34.6,0,0,1-.067,14.794,34.923,34.923,0,0,1-14.894.033S629.856,286.462,631.76,279.583Z" transform="translate(-621.3 -272.11)" fill="#ff0091" stroke="#c90072" strokeMiterlimit={10} strokeWidth={1} />
                                        </g>
                                        <image id="Image_44" data-name="Image 44" width={11} height={11} transform="translate(558.465 752.613)" xlinkHref="data:image/png;base64,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" />
                                    </g>
                                </svg>
                            </div>
                            <p className="text-white text-xxs xsm:text-xs sm:text-sm lg:text-base mt-1 sm:mt-0">Created by <span className="text-cusYellow">DennisRodmansBarbersh</span></p>

                            <p className="xs:mt-2 xl:mt-5 text-xxs xl:text-xs 3xl:text-sm text-white lg:w-9/12 hidden md:block">Welcome to the official collection page for Dennis Rodman's Barbershop.
                                To join the barbershop you can mint your own Dennis Rodman Barbershop NFT for 0.05 ETH from the official mint page, linked here: <a href="" className="text-cusLink">Know More</a></p>


                            <div className="hidden md:flex justify-center items-center bg-white dark:bg-[#8782FF76] w-fit mt-2 2xl:mt-3
                                px-2.5 py-1 2xl:px-3 2xl:py-1.5 rounded-md divide-x-2 divide-[#00000010] dark:divide-[#342A6B]">
                                <button
                                    onClick={() => setShowFollowersModal(!showFollowersModal)}
                                    className="flex justify-center items-center mr-1.5 xsm:mr-4">
                                    <span className="text-xs xsm:text-sm 2xl:text-base text-cusBlack dark:text-cusBrightLink font-bold">20</span>
                                    <p className="text-xxs xsm:text-xs 2xl:text-sm ml-1 xsm:ml-1.5 tracking-wider text-cusBlack dark:text-white font-bold">Followers</p>
                                </button>

                                <button
                                    onClick={() => setShowFollowingModal(!showFollowingModal)}
                                    className="flex justify-center items-center pl-1.5 xsm:pl-4">
                                    <span className="text-xs xsm:text-sm 2xl:text-base text-cusBlack dark:text-cusBrightLink font-bold">20</span>
                                    <p className="text-xxs xsm:text-xs 2xl:text-sm ml-1 xsm:ml-1.5 tracking-wider text-cusBlack dark:text-white font-bold">Following</p>
                                </button>
                            </div>



                            <div className="p-1.5 xsm:p-2.5 flex justify-between items-center
                            rounded-md bg-l-White dark:bg-[#8782ffc2] mt-2 md:hidden w-fit">
                                <svg className="w-[10px] sm:w-[11px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                    <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                    <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                    <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                    <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                    <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                    <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                                </svg>
                                <p className="text-xxs sm:text-xs text-cusBlack dark:text-white ml-3">0x60e4d7.....6a7c6</p>
                            </div>
                        </div>
                    </div>



                    <div className="mt-2 lg:mt-0 w-full lg:w-fit">
                        <div className="bg-white rounded-md lg:rounded-lg xl:rounded-xl xs:px-3 3xl:px-4 xs:py-1 lg:py-2 3xl:py-3
                         grid grid-cols-6 lg:grid-cols-3 xl:grid-cols-6 gap-x-2 md:gap-x-3 gap-y-1 w-full md:w-fit lg:ml-auto">
                            <div>
                                <h3 className="text-black text-xxs xxsm:text-xs sm:text-sm xl:text-base 3xl:text-xl font-black">$1.4M</h3>
                                <p className="text-3xs sm:text-xxs xl:text-xs 2xl:text-sm text-gray-500 
                                whitespace-nowrap overflow-hidden overflow-ellipsis">Highest Sale</p>
                            </div>
                            <div>
                                <h3 className="text-black text-xxs xxsm:text-xs sm:text-sm xl:text-base 3xl:text-xl font-black">$79.1K</h3>
                                <p className="text-3xs sm:text-xxs xl:text-xs 2xl:text-sm text-gray-500 
                                whitespace-nowrap overflow-hidden overflow-ellipsis">Floor price</p>
                            </div>
                            <div>
                                <h3 className="text-black text-xxs xxsm:text-xs sm:text-sm xl:text-base 3xl:text-xl font-black">$1.5B</h3>
                                <p className="text-3xs sm:text-xxs xl:text-xs 2xl:text-sm text-gray-500 
                                whitespace-nowrap overflow-hidden overflow-ellipsis">Market Cap</p>
                            </div>
                            <div>
                                <h3 className="text-black text-xxs xxsm:text-xs sm:text-sm xl:text-base 3xl:text-xl font-black">18.6K</h3>
                                <p className="text-3xs sm:text-xxs xl:text-xs 2xl:text-sm text-gray-500 
                                whitespace-nowrap overflow-hidden overflow-ellipsis">Items</p>
                            </div>
                            <div>
                                <h3 className="text-black text-xxs xxsm:text-xs sm:text-sm xl:text-base 3xl:text-xl font-black">12.3K</h3>
                                <p className="text-3xs sm:text-xxs xl:text-xs 2xl:text-sm text-gray-500 
                                whitespace-nowrap overflow-hidden overflow-ellipsis">Owners</p>
                            </div>
                            <div>
                                <h3 className="text-black text-xxs xxsm:text-xs sm:text-sm xl:text-base 3xl:text-xl font-black">$1.1B</h3>
                                <p className="text-3xs sm:text-xxs xl:text-xs 2xl:text-sm text-gray-500 
                                whitespace-nowrap overflow-hidden overflow-ellipsis">Total Volume</p>
                            </div>
                        </div>

                        <div className="xs:justify-start xl:justify-end items-center xs:mt-3 sm:mt-2 xl:mt-3 space-x-1 xl:space-x-2
                        hidden md:flex">
                            <div className="mr-2 xl:mr-5
                            p-[8px] lg:p-[8px] xl:p-[10px] 2xl:p-[14px]
                             flex justify-between items-center rounded-md lg:rounded-lg bg-l-White dark:bg-[#8782ffc2]">
                                <svg className="w-[12px] lg:w-[14px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                    <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                    <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                    <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                    <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                    <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                    <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                                </svg>
                                <p className="text-xs text-cusBlack dark:text-white ml-3">0x60e4d7.....6a7c6</p>
                            </div>


                            <div className="">
                                <motion.button
                                    whileTap={{ scale: 0.84 }}
                                    transition={{ duration: 0.2 }}
                                    onClick={() => setIsFollow(!isFollow)}
                                    className="bg-white dark:bg-[#4f2d77]
                                    py-[7.5px] lg:py-[9px] 2xl:py-[13px] px-[17px] 2xl:px-[20px]
                                    rounded-lg text-cusBlack dark:text-white mr-1
                                hover:bg-gradient-to-tl from-[#00DBFF] via-[#E315E8] to-[#FFD817] hover:text-white
                                shadow-lg tracking-wider font-extrabold text-sm xl:text-base">
                                    {isFollow ? "Unfollow" : "Follow"}
                                </motion.button>
                            </div>




                            <button
                                onClick={messageBtnOnClick}
                                className="global_icons_only_hover relative filter drop-shadow-sm md:drop-shadow-lg flex justify-center items-center
                            h-[36px] w-[36px]
                            lg:w-[40px] lg:h-[40px]
                            xl:w-[45px] xl:h-[45px] 
                            2xl:w-[52px] 2xl:h-[52px]">
                                <svg className="w-full h-full absolute inset-0 z-[-1]
                                fill-[#EFEFEF] stroke-[#EFEFEF] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                    viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                                </svg>

                                <svg xmlns="http://www.w3.org/2000/svg" className="blackWhiteSVG w-[15px] h-[15px] lg:w-[20px] lg:h-[20px] 2xl:w-[26px] 2xl:h-[26px]" viewBox="0 0 26.167 22.365">
                                    <path id="text_1_" data-name="text (1)" d="M27.244,26a9.245,9.245,0,0,0-5.319,16.8l8.59,5.56V45.057a.569.569,0,0,1,.569-.569h3.84a9.244,9.244,0,0,0,0-18.488ZM25.465,36.95a1.138,1.138,0,1,0-1.138-1.138A1.138,1.138,0,0,0,25.465,36.95Zm5.619,0a1.138,1.138,0,1,0-1.138-1.138A1.138,1.138,0,0,0,31.084,36.95Zm5.619,0a1.138,1.138,0,1,0-1.138-1.138A1.138,1.138,0,0,0,36.7,36.95Z" transform="translate(-18 -26)" fill="#3f2063" fillRule="evenodd" />
                                </svg>
                            </button>


                            <button
                                onClick={() => setShareModalOpen(!shareModalOpen)}
                                className="global_icons_only_hover relative filter drop-shadow-sm md:drop-shadow-lg flex justify-center items-center
                            h-[36px] w-[36px]
                            lg:w-[40px] lg:h-[40px]
                            xl:w-[45px] xl:h-[45px]
                            2xl:w-[52px] 2xl:h-[52px]">
                                <svg className="w-full h-full absolute inset-0 z-[-1]
                                fill-[#EFEFEF] stroke-[#EFEFEF] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                    viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" className="blackWhiteSVG w-[15px] h-[15px] lg:w-[18px] lg:h-[18px] 2xl:w-[22px] 2xl:h-[22px]" width="24.476" height="24.475" viewBox="0 0 24.476 24.475">
                                    <path id="Union_10" data-name="Union 10" d="M10136.334,14296.156a4.8,4.8,0,0,1,.262-1.57l-6.182-3.3a4.822,4.822,0,1,1,.015-5.075l6.177-3.294a4.828,4.828,0,1,1,.706,1.313l-6.306,3.363a4.849,4.849,0,0,1-.007,2.314l6.3,3.358a4.82,4.82,0,1,1-.961,2.888Z" transform="translate(-10121.501 -14276.502)" fill="#3f2063" />
                                </svg>
                            </button>

                            <button
                                onClick={() => setThreeDotModalOpen(!threeDotModalOpen)}
                                className="global_icons_only_hover relative filter drop-shadow-sm md:drop-shadow-lg flex justify-center items-center
                            h-[36px] w-[36px]
                            lg:w-[40px] lg:h-[40px]
                            xl:w-[45px] xl:h-[45px]
                            2xl:w-[52px] 2xl:h-[52px]">
                                <svg className="w-full h-full absolute inset-0 z-[-1]
                                fill-[#EFEFEF] stroke-[#EFEFEF] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                    viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" className="blackWhiteSVG w-[15px] h-[15px] lg:w-[18px] lg:h-[18px] 2xl:w-[20px] 2xl:h-[20px]" viewBox="0 0 4 16">
                                    <path id="Combined_Shape" data-name="Combined Shape" d="M12,2a2,2,0,1,1,2,2A2,2,0,0,1,12,2ZM6,2A2,2,0,1,1,8,4,2,2,0,0,1,6,2ZM0,2A2,2,0,1,1,2,4,2,2,0,0,1,0,2Z" transform="translate(0 16) rotate(-90)" fill="#fff" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="px-5 xsm:px-8 sm:px-0 sm:max-w-[570px] md:max-w-[660px] lg:max-w-[900px] xl:max-w-[1100px] 2xl:max-w-[1336px] 3xl:max-w-[1436px]
                mx-auto  h-full relative">

                <div className="pt-3 md:hidden">
                    <p className="text-left text-xxs xsm:text-xs sm:text-sm text-cusBlack dark:text-white">Welcome to the official collection page for Dennis Rodman's Barbershop.
                        To join the barbershop you can mint your own Dennis Rodman Barbershop NFT for 0.05 ETH from the official mint page, linked here: <a href="" className="text-cusBlack font-bold dark:font-medium dark:text-cusLink">Know More</a></p>

                    <div className="flex justify-between items-center mt-4 w-full overflow-auto">

                        <div className="flex justify-center items-center bg-white dark:bg-[#8782FF76]
                        px-2 xsm:px-3 py-2 xsm:py-1.5 rounded-md divide-x-2 divide-[#00000010] dark:divide-[#342A6B]">
                            <button
                                onClick={() => setShowFollowersModal(!showFollowersModal)}
                                className="flex justify-center items-center mr-1.5 xsm:mr-4">
                                <span className="text-xs xsm:text-sm sm:text-base text-cusBlack dark:text-cusBrightLink font-bold">20</span>
                                <p className="text-xxs xsm:text-xs sm:text-sm ml-1 xsm:ml-1.5 tracking-wider text-cusBlack dark:text-white font-bold">Followers</p>
                            </button>

                            <button
                                onClick={() => setShowFollowingModal(!showFollowingModal)}
                                className="flex justify-center items-center pl-1.5 xsm:pl-4">
                                <span className="text-xs xsm:text-sm sm:text-base text-cusBlack dark:text-cusBrightLink font-bold">20</span>
                                <p className="text-xxs xsm:text-xs sm:text-sm ml-1 xsm:ml-1.5 tracking-wider text-cusBlack dark:text-white font-bold">Following</p>
                            </button>
                        </div>



                        <div className="justify-end items-center space-x-0.5 xxsm:space-x-1 xsm:space-x-2 flex md:hidden flex-1">

                            <button
                                onClick={messageBtnOnClick}
                                className="global_icons_only_hover relative filter drop-shadow-sm md:drop-shadow-lg flex justify-center items-center
                                    h-[37px] w-[37px]
                                    xsm:h-[40px] xsm:w-[40px]
                                    sm:h-[45px] sm:w-[45px]
                            ">
                                <svg className="w-full h-full absolute inset-0 z-[-1]
                                fill-[#ffffff] stroke-[#eeeeee] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                    viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                                </svg>

                                <svg xmlns="http://www.w3.org/2000/svg" className="blackWhiteSVG w-[15px] h-[15px]" viewBox="0 0 26.167 22.365">
                                    <path id="text_1_" data-name="text (1)" d="M27.244,26a9.245,9.245,0,0,0-5.319,16.8l8.59,5.56V45.057a.569.569,0,0,1,.569-.569h3.84a9.244,9.244,0,0,0,0-18.488ZM25.465,36.95a1.138,1.138,0,1,0-1.138-1.138A1.138,1.138,0,0,0,25.465,36.95Zm5.619,0a1.138,1.138,0,1,0-1.138-1.138A1.138,1.138,0,0,0,31.084,36.95Zm5.619,0a1.138,1.138,0,1,0-1.138-1.138A1.138,1.138,0,0,0,36.7,36.95Z" transform="translate(-18 -26)" fill="#3f2063" fillRule="evenodd" />
                                </svg>
                            </button>

                            <button
                                onClick={() => setShareModalOpen(!shareModalOpen)}
                                className="global_icons_only_hover relative filter drop-shadow-sm md:drop-shadow-lg flex justify-center items-center
                                    h-[37px] w-[37px]
                                    xsm:h-[40px] xsm:w-[40px]
                                    sm:h-[45px] sm:w-[45px]">
                                <svg className="w-full h-full absolute inset-0 z-[-1]
                                fill-[#ffffff] stroke-[#eeeeee] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                    viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                                </svg>

                                <svg xmlns="http://www.w3.org/2000/svg" className="blackWhiteSVG w-[15px] h-[15px] lg:w-[18px] lg:h-[18px] 2xl:w-[22px] 2xl:h-[22px]" width="24.476" height="24.475" viewBox="0 0 24.476 24.475">
                                    <path id="Union_10" data-name="Union 10" d="M10136.334,14296.156a4.8,4.8,0,0,1,.262-1.57l-6.182-3.3a4.822,4.822,0,1,1,.015-5.075l6.177-3.294a4.828,4.828,0,1,1,.706,1.313l-6.306,3.363a4.849,4.849,0,0,1-.007,2.314l6.3,3.358a4.82,4.82,0,1,1-.961,2.888Z" transform="translate(-10121.501 -14276.502)" fill="#3f2063" />
                                </svg>
                            </button>

                            <button
                                onClick={() => setThreeDotModalOpen(!threeDotModalOpen)}
                                className="global_icons_only_hover relative filter drop-shadow-sm md:drop-shadow-lg flex justify-center items-center
                                    h-[37px] w-[37px]
                                    xsm:h-[40px] xsm:w-[40px]
                                    sm:h-[45px] sm:w-[45px]
                              ">
                                <svg className="w-full h-full absolute inset-0 z-[-1]
                                fill-[#ffffff] stroke-[#eeeeee] dark:fill-[#4f2d77] dark:stroke-[#4f2d77] unactive_bg"
                                    viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.47527 3.49395C3.47527 3.49395 30.2863 -3.23805 55.3563 3.49395C55.3563 3.49395 61.3913 26.359 55.1243 54.911C38.0783 58.6715 20.4218 58.7111 3.35924 55.027C3.35924 55.027 -3.13973 27.403 3.47527 3.49395Z" strokeMiterlimit={10} />
                                </svg>

                                <svg xmlns="http://www.w3.org/2000/svg" className="blackWhiteSVG w-[15px] h-[15px] lg:w-[18px] lg:h-[18px] 2xl:w-[20px] 2xl:h-[20px]" viewBox="0 0 4 16">
                                    <path id="Combined_Shape" data-name="Combined Shape" d="M12,2a2,2,0,1,1,2,2A2,2,0,0,1,12,2ZM6,2A2,2,0,1,1,8,4,2,2,0,0,1,6,2ZM0,2A2,2,0,1,1,2,4,2,2,0,0,1,0,2Z" transform="translate(0 16) rotate(-90)" fill="#fff" />
                                </svg>
                            </button>
                        </div>




                    </div>


                </div>







                <div className="flex justify-start items-end mt-8 relative">
                    <NavLink to="/publicProfile/item" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                        Item
                    </NavLink>
                    <NavLink to="/publicProfile/activity" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                        Activity
                    </NavLink>
                    <NavLink to="/publicProfile/stats" className={({ isActive }) => (isActive ? `${smallNavItemStyles} active` : `${smallNavItemStyles}`)}>
                        Stats
                    </NavLink>
                    <div className="w-full border-2 border-[#DEDEDE] dark:border-[#201753] flex-1 align-bottom"></div>
                </div>

                <Outlet />
            </div>













            {/* Profile Share Modal */}
            <AnimatePresence>
                {shareModalOpen &&
                    <div
                        className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={shareModalOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={shareModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                                    rounded-2xl text-left overflow-hidden transform transition-all sm:align-middle
                                                 w-11/12 xsm:max-w-sm md:max-w-sm xl:max-w-md xsm:w-full">

                                <div className="flex justify-between items-center px-6 pt-5">
                                    <h5 className="text-cusBlack dark:text-white text-xl font-extrabold dark:font-bold">Share</h5>

                                    <button onClick={() => setShareModalOpen(false)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                            <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                        </svg>
                                    </button>
                                </div>
                                <div className="border-b border-[#dedede] dark:border-[#473a94] mt-2"></div>

                                <div className="px-6 py-3 flex justify-start items-center">
                                    <p className="text-cusBlack dark:text-white font-bold">To:</p>
                                    <input type="text" name="" id=""
                                        onChange={handleShareModalSearch}
                                        placeholder="Search..."
                                        className="bg-transparent outline-none w-full ml-2 text-cusBlack dark:text-white"
                                    />
                                </div>

                                <div className="border-b border-[#dedede] dark:border-[#473a94]"></div>

                                <div className="pl-6 pt-3">
                                    <p className="text-cusBlack dark:text-white font-bold text-sm">Suggested</p>

                                    <div className="flex flex-col pb-2 h-[200px] sm:h-[300px] xl:h-[320px] overflow-auto mt-2">
                                        {modalPeoplesData.map((people, index) =>
                                            <label htmlFor={`shareToPeople${index}`} key={people.id}>
                                                <div className="flex justify-between items-center 
                                                hover:bg-[#00000010] dark:hover:bg-[#00000020] pl-3 py-[7px] pr-7 rounded-l-lg">
                                                    <div className="flex justify-start items-center">
                                                        <div className="
                                                        w-[40px] h-[40px]
                                                        md:w-[50px] md:h-[50px] rounded-full overflow-hidden">
                                                            <div>
                                                                <img src={people.photo} alt="" className="w-full h-full" />
                                                            </div>
                                                        </div>
                                                        <div className="text-left ml-3">
                                                            <h5 className="text-cusBlack dark:text-white text-sm lg:text-base
                                                            max-w-[100px] xxsm:max-w-[120px] sm:max-w-[160px] truncate">{people.name}</h5>
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <input type="checkbox"
                                                            name="shareToPeopleCheckbox" id={`shareToPeople${index}`}
                                                            className="bg-transparent cursor-pointer border-2 dark:border-[#ff0091]
                                                            dark:checked:bg-[#ff0091] checked:bg-[#2563eb] dark:focus:outline-pink-600
                                                            w-4 h-4 md:w-5 md:h-5 focus:outline-none rounded-full form-checkbox transition-all" />
                                                    </div>
                                                </div>

                                            </label>
                                        )}
                                    </div>
                                </div>


                                <div className="px-6 py-3 xl:py-4">
                                    <button className="w-full py-2 gradientBG text-white font-bold rounded-md
                                     hover:tracking-wider transition-all duration-300">
                                        Send
                                    </button>

                                    <button className="w-full py-2 flex justify-center items-center mt-3 border-2 border-[#c5c5c5] dark:border-[#8481c5]
                                rounded-lg group
                                    ">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 md:w-6 stroke-l-LightBlack dark:stroke-cusBlueWhite" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
                                        </svg>

                                        <p className="text-l-LightBlack dark:text-cusBlueWhite ml-1 font-semibold 
                                        group-hover:tracking-wider transition-all duration-300 select-none text-sm md:text-base
                                        ">Copy Link</p>
                                    </button>
                                </div>

                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>






            {/* Profile Three dot Modal */}
            <AnimatePresence>
                {threeDotModalOpen &&
                    <div
                        className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={threeDotModalOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={threeDotModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                                    rounded-2xl text-left overflow-hidden transform transition-all sm:align-middle
                                                  max-w-xs xl:max-w-sm w-full">

                                <div className="flex flex-col justify-center items-center">
                                    <button className="
                                    text-xs sm:text-sm lg:text-base
                                    hover:bg-[#00000008] dark:hover:bg-[#00000020] transition-all py-4 text-red-500 font-semibold w-full" >
                                        Block
                                    </button>
                                    <div className="w-full border-b border-[#dedede] dark:border-[#473a94]"></div>

                                    <button className="
                                    text-xs sm:text-sm lg:text-base
                                    hover:bg-[#00000008] dark:hover:bg-[#00000020] transition-all py-4 text-red-500 font-semibold w-full" >
                                        Restrict
                                    </button>
                                    <div className="w-full border-b border-[#dedede] dark:border-[#473a94]"></div>

                                    <button
                                        onClick={() => { setReportModalOpen(!reportModalOpen); setThreeDotModalOpen(false) }}
                                        className="text-xs sm:text-sm lg:text-base
                                    hover:bg-[#00000008] dark:hover:bg-[#00000020] transition-all py-4 text-red-500 font-semibold w-full" >
                                        Report
                                    </button>
                                    <div className="w-full border-b border-[#dedede] dark:border-[#473a94]"></div>

                                    <button className="
                                    text-xs sm:text-sm lg:text-base
                                    hover:bg-[#00000008] dark:hover:bg-[#00000020] transition-all py-4 text-cusBlack dark:text-white font-semibold w-full" >
                                        Embed
                                    </button>
                                    <div className="w-full border-b border-[#dedede] dark:border-[#473a94]"></div>

                                    <button
                                        onClick={() => setThreeDotModalOpen(false)}
                                        className="
                                        text-xs sm:text-sm lg:text-base
                                        hover:bg-[#00000008] dark:hover:bg-[#00000020] transition-all py-4 text-cusBlack dark:text-white font-semibold w-full" >
                                        Cancel
                                    </button>
                                    <div className="w-full border-b border-[#dedede] dark:border-[#473a94]"></div>

                                </div>
                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>


            {/* Report Modal */}
            <AnimatePresence>
                {reportModalOpen &&
                    <div
                        className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={reportModalOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={reportModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                                    rounded-2xl text-left transform transition-all sm:align-middle
                                                  max-w-sm xl:max-w-lg w-full">
                                <div className="px-6 py-5">
                                    <div className="flex justify-between items-center">
                                        <h5 className="text-cusBlack dark:text-white text-base xxsm:text-xl font-extrabold dark:font-bold">Report this account</h5>

                                        <button onClick={() => setReportModalOpen(false)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                                <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            </svg>
                                        </button>
                                    </div>

                                    <div className="my-8">
                                        <p className="text-cusBlack dark:text-white font-semibold inline-block cursor-default text-xs xxsm:text-sm xsm:text-base">I think this account is...</p>

                                        <div
                                            ref={reasonDropRef}
                                            className="border-2 border-[#e6e8ec] hover:border-gray-300 dark:hover:border-gray-400
                                            dark:border-[#e6e8ec20] px-3 py-3 rounded-md md:rounded-lg mt-1 transition-all cursor-pointer relative w-full text-left"
                                            onClick={() => setReportDropOpen(!reasonDropOpen)}>
                                            <div className="flex justify-between items-center break-all">
                                                <h4 className="text-l-LightBlack dark:text-white font-semibold text-xs md:text-sm truncate">{reasonText}</h4>
                                                <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 blackWhiteSVG3 transition-all ${reasonDropOpen && 'rotate-180'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </div>
                                            <AnimatePresence>
                                                {reasonDropOpen &&
                                                    <motion.div
                                                        animate={reasonDropOpen ? "open" : "closed"}
                                                        initial={{ y: -15, }}
                                                        variants={{
                                                            open: { y: 0, },
                                                            closed: { y: -100, },
                                                        }}
                                                        exit={{ opacity: 0, y: -15 }}
                                                        transition={{ duration: 0.2 }}
                                                        className="rounded-xl overflow-hidden absolute top-10 md:top-12 bg-white dark:bg-[#3b316e] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20">
                                                        {[
                                                            "Fake collection or possible scam",
                                                            "Explicit and sensitive content",
                                                            "Spam",
                                                            "Might be stolen",
                                                            "Harassment",
                                                            "False information",
                                                            "Unauthorized Sales",
                                                            "Hate Speech",
                                                            "Terrorism",
                                                            "Something Else",
                                                            "Other",
                                                        ].map(item =>
                                                            <div onClick={() => { setReasonText(item) }}
                                                                className="py-1.5 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all" key={item}>
                                                                <p className="text-cusBlack dark:text-white text-xs lg:text-sm font-normal truncate">{item}</p>
                                                            </div>
                                                        )}
                                                    </motion.div>}
                                            </AnimatePresence>
                                        </div>
                                    </div>


                                    <button
                                        onClick={() => setReportModalOpen(false)}
                                        className="gradientBtn w-full py-3 rounded-lg text-white font-semibold text-xs xxsm:text-sm xsm:text-base">
                                        Report Now
                                    </button>

                                </div>
                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>






            {/* Followers modal */}
            <AnimatePresence>
                {showFollowersModal &&
                    <div
                        className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen pt-4 px-4 text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={showFollowersModal ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={followersModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                    rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:align-middle
                                    max-w-sm md:max-w-sm w-full h-[80vh] sm:h-[70vh] lg:h-auto pb-14 lg:pb-0">

                                <div className="flex justify-between items-center px-6 pt-5 pb-4">
                                    <h5 className="text-cusBlack dark:text-white text-2xl font-extrabold">Followers</h5>

                                    <button onClick={() => setShowFollowersModal(false)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                            <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                        </svg>
                                    </button>
                                </div>

                                <div className="pb-6 pl-6 pr-4 flex flex-col h-full lg:max-h-[500px] overflow-y-auto">
                                    {allFollowersPeoplesData.map(people =>
                                        <div key={people.id}
                                            className="flex justify-start items-center w-full mb-4 break-all">
                                            <div className="">
                                                <div className="w-8 h-9 xsm:w-10 xsm:h-10 md:w-12 md:h-12 rounded-full overflow-hidden">
                                                    <img src={people.photo} alt="" className="w-full" />
                                                </div>
                                            </div>

                                            <div className="ml-2 xsm:ml-4 flex-1 w-full">
                                                <h5 className="font-bold w-full text-cusBlack dark:text-white max-w-[90px] xxsm:max-w-[120px]
                                                    sm:max-w-[140px] truncate text-sm md:text-base">{people.name}</h5>

                                                <p className="text-l-LightBlack dark:text-cusBlueWhite xsm:mt-0.5
                                                    whitespace-nowrap overflow-hidden overflow-ellipsis text-xxs xsm:text-xs md:text-sm">{abbreviateNumber(people.followersNum)} Followers</p>
                                            </div>


                                            <motion.button
                                                whileHover={{ scale: 1.1 }}
                                                whileTap={{ scale: 0.9 }}
                                                transition={{ duration: 0.2 }}
                                                className="dark:border bg-cusBlack dark:bg-[#363375] dark:border-[#58549c]
                                                    px-2.5 py-1.5 xsm:px-3 xsm:py-2 md:px-6 md:py-2
                                                    rounded-md md:rounded-lg text-white font-semibold text-xxs xxsm:text-xs md:text-sm">
                                                Add
                                            </motion.button>
                                        </div>
                                    )
                                    }
                                </div>
                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>



            {/* Following modal */}
            <AnimatePresence>
                {showFollowingModal &&
                    <div
                        className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen pt-4 px-4 text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={showFollowingModal ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={followingModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                    rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:align-middle
                                    max-w-sm md:max-w-sm w-full h-[80vh] sm:h-[70vh] lg:h-auto pb-14 lg:pb-0">

                                <div className="flex justify-between items-center px-6 pt-5 pb-4">
                                    <h5 className="text-cusBlack dark:text-white text-2xl font-extrabold">Following</h5>

                                    <button onClick={() => setShowFollowingModal(false)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                            <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                        </svg>
                                    </button>
                                </div>

                                <div className="pb-6 pl-6 pr-4 flex flex-col h-full lg:max-h-[500px] overflow-y-auto">
                                    {allFollowersPeoplesData.map(people =>
                                        <div key={people.id}
                                            className="flex justify-start items-center w-full mb-4 break-all">
                                            <div className="">
                                                <div className="w-8 h-9 xsm:w-10 xsm:h-10 md:w-12 md:h-12 rounded-full overflow-hidden">
                                                    <img src={people.photo} alt="" className="w-full" />
                                                </div>
                                            </div>

                                            <div className="ml-2 xsm:ml-4 flex-1 w-full">
                                                <h5 className="font-bold w-full text-cusBlack dark:text-white max-w-[90px] xxsm:max-w-[120px]
                                                    sm:max-w-[140px] truncate text-sm md:text-base">{people.name}</h5>

                                                <p className="text-l-LightBlack dark:text-cusBlueWhite xsm:mt-0.5
                                                    whitespace-nowrap overflow-hidden overflow-ellipsis text-xxs xsm:text-xs md:text-sm">{abbreviateNumber(people.followersNum)} Followers</p>
                                            </div>


                                            <motion.button
                                                whileHover={{ scale: 1.1 }}
                                                whileTap={{ scale: 0.9 }}
                                                transition={{ duration: 0.2 }}
                                                className="dark:border bg-cusBlack dark:bg-[#363375] dark:border-[#58549c]
                                                    px-2.5 py-1.5 xsm:px-3 xsm:py-2 md:px-6 md:py-2
                                                    rounded-md md:rounded-lg text-white font-semibold text-xxs xxsm:text-xs md:text-sm">
                                                Add
                                            </motion.button>
                                        </div>
                                    )
                                    }
                                </div>
                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>


















        </div>
    );
}
